import {Component, OnInit} from '@angular/core';
import {RegistryService} from "../../../../services/registry.service";
import {CartService} from "../../../../services/cart.service";
import {Cart} from "../../../../models/CartModels/cart";

import {CartItem} from "../../../../models/CartModels/cartItem";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-language-icon',
    templateUrl: './language-icon.component.html',
    styleUrls: ['./language-icon.component.css']
})
export class LanguageIconComponent implements OnInit {


    products_count = 0;
    cart: Cart;
    baseImageUrl;
    sum = 0;

    lang = 'en-US';



    constructor(private registry: RegistryService,
                private cartService: CartService,
                public translate: TranslateService
    ) {


    }

    ngOnInit(): void {

        this.lang = this.cartService.getCurrentLang();

    }

    changeToEnglish(){
        this.removeSearchBarValue(null);
        this.translate.use('en');

    }

    changeToArabic(){
        this.removeSearchBarValue(null);
        this.translate.use('ar')

    }

    removeSearchBarValue(event) {
        if(event != null){
            event.preventDefault();
        }
        localStorage.setItem('searchKeyword' , '');
    }


}
